import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

const PatientMedications = ({ medications }) => (
  <Paper sx={{ padding: 2 }}>
    <Typography variant='h6'>Medications</Typography>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          <TableCell>Medication</TableCell>
          <TableCell>Dosage</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {medications.map((medication) => (
          <TableRow key={medication.id}>
            <TableCell>{medication.date}</TableCell>
            <TableCell>{medication.medication}</TableCell>
            <TableCell>{medication.dosage}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Paper>
);

export default PatientMedications;
